let $featuredProductsSwiper = document.querySelector('.js-featured-products-swiper');

if ($featuredProductsSwiper) {
  const prevButton = document.querySelector('.js-featured-products-prev');
  const nextButton = document.querySelector('.js-featured-products-next');
  const progressBar = document.querySelector('.js-featured-products-progress-bar');
  
  // Count original slides before Swiper duplicates them for loop
  const originalSlidesCount = $featuredProductsSwiper.querySelectorAll('.swiper-slide').length;
  
  // Define updateProgress function first
  function updateProgress(swiperInstance) {
    if (progressBar && swiperInstance && originalSlidesCount > 0) {
      // Get the real index accounting for loop
      const realIndex = swiperInstance.realIndex;
      // Calculate progress based on real index and original slide count
      const progress = ((realIndex + 1) / originalSlidesCount) * 100;
      progressBar.style.width = progress + '%';
    }
  }
  
  let featuredProductsSwiper = new Swiper($featuredProductsSwiper, {
    speed: 600,
    slidesPerView: 2,
    spaceBetween: 12,
    loop: true,
    allowTouchMove: true,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    breakpoints: {
      960: {
        slidesPerView: 4,
        spaceBetween: 12
      }
    },
    on: {
      slideChange: function() {
        updateProgress(this);
      },
      init: function() {
        updateProgress(this);
      }
    }
  });
}